module.exports = __webpack_public_path__ + "img/logohauseful.cf31abcf.svg";